import React, { useState } from "react";
import { Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PopUpWindow from "../popUpWindow/PopUpWindow";
import ChargeForm from "../chargeForm/ChargeForm";

const AddChargeButton = ({ selectedProperty, selectedInvoice, onChargeAdded }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleChargeCreated = (newCharge) => {
    // Call the parent callback if provided
    if (onChargeAdded) {
      onChargeAdded(newCharge);
    }
    handleCloseForm();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleOutlineIcon />}
        onClick={handleOpenForm}
        sx={{ mb: 2 }}
      >
        Add Charge
      </Button>

      {isFormOpen && (
        <PopUpWindow
          onClose={handleCloseForm}
          title="Create New Charge"
          width="500px"
        >
          <ChargeForm
            onClose={handleCloseForm}
            onSuccess={handleChargeCreated}
            selectedProperty={selectedProperty}
            selectedInvoice={selectedInvoice}
          />
        </PopUpWindow>
      )}
    </>
  );
};

export default AddChargeButton;